import { Map, List } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

export class FavouritesStore extends BaseStore {

    getInitialState () {
        const favourites = new List();
        return new Map({ favourites });
    }

    getFavourite (fare, orderTrip) {
        return this.getFavourites().find(favourite => favourite.matchFare(fare, orderTrip));
    }

    getFavouriteById (favouriteId) {
        return this.getFavourites().find(({ id }) => id === favouriteId);
    }

    getFavourites () {
        return this.get('favourites');
    }

    handleFavouriteAdded ({ favourite }) {
        const favourites = this.getFavourites().push(favourite);
        this._setFavourites(favourites);
    }

    handleFavouritesLoaded ({ favourites }) {
        this._setFavourites(favourites);
    }

    handleFavouriteRemoved ({ favourite }) {
        const favourites = this.getFavourites().filterNot(fav => fav === favourite);
        this._setFavourites(favourites);
    }

    handleFavouritePhotocardUpdated ({ favouriteId, photocard }) {
        const favourites = this.getFavourites();
        const index = favourites.findIndex(fav => fav.id === favouriteId);
        this._setFavourites(favourites.setIn([index, 'photocard'], photocard));
    }

    handleFavouriteDeliveryAdded ({ favouriteId, deliveryId, delivery }) {
        const favourites = this.getFavourites();
        const index = favourites.findIndex(fav => fav.id === favouriteId);
        this._setFavourites(favourites.setIn([index, 'delivery'], delivery.set('id', deliveryId)));
    }

    handleFavouriteDeliveryUpdated ({ favouriteId, delivery }) {
        const favourites = this.getFavourites();
        const index = favourites.findIndex(fav => fav.id === favouriteId);
        this._setFavourites(favourites.setIn([index, 'delivery'], delivery));
    }

    handleFavouriteSeasonExpiryDateUpdated ({ favouriteId, seasonExpiryDate }) {
        const favourites = this.getFavourites();
        const index = favourites.findIndex(fav => fav.id === favouriteId);
        this._setFavourites(favourites.setIn([index, 'seasonExpiry'], seasonExpiryDate));
    }

    handleFavouriteLastUsedDateUpdated ({ favouriteId, lastUsedDate }) {
        const favourites = this.getFavourites();
        const index = favourites.findIndex(fav => fav.id === favouriteId);
        this._setFavourites(favourites.setIn([index, 'lastUsed'], lastUsedDate));
    }

    // Firstly sort by season tickets expiring soon,
    // then by date last used
    _sortFavourites (favourites) {
        return favourites.sort((a, b) => {
            // Compare season ticket expiry
            let compareExpiringSoon = 0;
            if (a.isExpiringSoon() && !b.isExpiringSoon()) {
                compareExpiringSoon = -1;
            } else if (!a.isExpiringSoon() && b.isExpiringSoon()) {
                compareExpiringSoon = 1;
            } else if (a.isExpiringSoon() && b.isExpiringSoon()) {
                compareExpiringSoon = a.getDaysToExpiry() - b.getDaysToExpiry();
            }

            // Compare date last used
            let compareLastUsed = 0;
            if (a.lastUsed && !b.lastUsed) {
                compareLastUsed = -1;
            } else if (!a.lastUsed && b.lastUsed) {
                compareLastUsed = 1;
            } else if (a.lastUsed && b.lastUsed) {
                compareLastUsed = b.lastUsed - a.lastUsed;
            }

            // Last resort, sort by most recently created
            const compareMostRecentlyCreated = b.id - a.id;

            return compareExpiringSoon || compareLastUsed || compareMostRecentlyCreated;
        });
    }

    _setFavourites (favourites) {
        this.setState(this.state.set('favourites', this._sortFavourites(favourites)));
    }

    getActionHandlers () {
        return {
            [ ActionTypes.FAVOURITES_ADDED ]: this.handleFavouriteAdded,
            [ ActionTypes.FAVOURITES_REMOVED ]: this.handleFavouriteRemoved,
            [ ActionTypes.FAVOURITES_LOADED ]: this.handleFavouritesLoaded,
            [ ActionTypes.FAVOURITES_PHOTOCARD_UPDATED ]: this.handleFavouritePhotocardUpdated,
            [ ActionTypes.FAVOURITES_DELIVERY_ADDED ]: this.handleFavouriteDeliveryAdded,
            [ ActionTypes.FAVOURITES_DELIVERY_UPDATED ]: this.handleFavouriteDeliveryUpdated,
            [ ActionTypes.FAVOURITES_SEASON_EXPIRY_DATE_UPDATED ]: this.handleFavouriteSeasonExpiryDateUpdated,
            [ ActionTypes.FAVOURITES_LAST_USED_DATE_UPDATED ]: this.handleFavouriteLastUsedDateUpdated,
        };
    }
}

export default new FavouritesStore();



// WEBPACK FOOTER //
// ./src/stores/FavouritesStore.js